<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">序时账</span>
				<div class="float-right">
					<Button size="s" icon="fa fa-print" @click="printPage">打印</Button>
					<Button size="s" icon="fa fa-download" @click="exportExcel">导出</Button>
				</div>
		</div>
		<Row type="flex" :space-x="10" class="margin-right-left padding-top" :align="'middle'">
			<Cell>
				<div class="h-input-group" v-width="350">
					<DatePicker v-model="params.start" style="width: 140px" :clearable="false" :option="{end:params.end}"
								format="YYYY-MM-dd"></DatePicker>
					<span class="h-input-addon">至</span>
					<DatePicker v-model="params.end" style="width: 140px" :clearable="false" :option="{start:params.start}"
								format="YYYY-MM-dd"></DatePicker>
				</div>
			</Cell>
			<Cell>
				<Select v-width="120" keyName="word" titleName="word" :clearable="true" :datas="voucherWords" v-model="params.word" placeholder="凭证字">
					<template slot-scope="scope">{{scope.row.word}}</template>
				</Select>
			</Cell>
			<Cell>
				<Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
			</Cell>
		</Row>
		<div class="h-panel-body">
			<table id="ioTable" class="cus-table">
				<thead class="header">
				<tr>
					<td>日期</td>
					<td>凭证字号</td>
					<td>摘要</td>
					<td>科目编码</td>
					<td>科目名称</td>
					<td>借方数量</td>
					<td>借方金额</td>
					<td>贷方数量</td>
					<td>贷方金额</td>
					<td>制单人</td>
					<td>审核人</td>
					<td>附件数</td>
					<td>备注</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(item,index) in dataList" :key="index">
					<td>{{item.voucherDate}}</td>
					<td>{{item.voucherCode}}</td>
					<td>{{item.summary}}</td>
					<td>{{item.subjectCode}}</td>
					<td>{{item.subjectName}}</td>
					<td class="text-right">{{item.debitNum|numFormat}}</td>
					<td class="text-right">{{item.debitAmount|numFormat}}</td>
					<td class="text-right">{{item.creditNum|numFormat}}</td>
					<td class="text-right">{{item.creditAmount|numFormat}}</td>
					<td>{{item.createMemberName}}</td>
					<td>{{item.auditMemberName}}</td>
					<td class="text-right">{{item.receiptNum}}</td>
					<td>{{item.remark}}</td>
				</tr>
				<tr v-if="!dataList.length">
					<td colspan="13" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
			<Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
						@change="currentChange" small align="right"/>
		</div>
	</app-content>
</template>

<script>
	import ioMixin from '../../js/common/io-mixin';
	import manba from "manba";

	export default {
		name: "TimeSeries",
		mixins: [ioMixin],
		data() {
			return {
				params: {
					start: manba().startOf(manba.MONTH).format(),
					end: manba().endOf(manba.MONTH).format(),
					word: null
				},
				voucherWords: [],
				loading: false,
				dataList: [],
				pagination: {
					page: 1,
					size: 20,
					total: 0
				}
			}
		},
		computed: {
			queryParams() {
				return {
					start: this.params.start,
					end: this.params.end,
					word: this.params.word || undefined,
					page: this.pagination.page,
					pageSize: this.pagination.size
				}
			}
		},
		methods: {
			printPage() {
				this.doPrint({title: '序时账', elId: 'ioTable', period: `${this.params.start} 至 ${this.params.end}`, landscape: true});
				},
			exportExcel() {
				this.doExport({name: '序时账', elId: 'ioTable', period: `${this.params.start} 至 ${this.params.end}`});
				},
			loadVoucherWords() {
				this.$api.voucherWord.list().then(({data}) => {
					this.voucherWords = data || [];
				});
			},
			doSearch() {
				this.pagination.page = 1;
				this.loadList();
			},
			currentChange() {
				this.loadList();
			},
			loadList() {
				this.loading = true;
				this.$api.accountbook.loadTimeSeries(this.queryParams).then(({data}) => {
					this.dataList = data.records || [];
					this.pagination.total = data.total;
					this.loading = false;
				});
			}
		},
		created() {
			this.loadVoucherWords();
			this.loadList();
		}
	}
</script>

<style scoped lang="less">
	.cus-table {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 32px;
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}
</style>
